"use client";

import { PageDecorLayer } from "@/components/decorative/PageDecorLayer";
import { PageHero } from "@/components/layout/PageHero";
import { SitePageShell } from "@/components/layout/SitePageShell";
import { ImpactSectorShowcase } from "@/components/impact/ImpactSectorShowcase";
import { ImpactGalleryStrip } from "@/components/impact/ImpactGalleryStrip";
import type { ImpactContent } from "@/lib/api-types";

type ImpactExplorerProps = {
  content: ImpactContent;
};

export function ImpactExplorer({ content }: ImpactExplorerProps) {
  return (
    <SitePageShell className="pb-16">
      <PageHero
        eyebrow={content.hero.eyebrow}
        title={content.hero.title}
        accentWord={content.hero.accentWord}
        subtitle={content.hero.subtitle}
        layout="split"
        align="left"
        image={{
          src: content.hero.imageSrc,
          alt: content.hero.imageAlt,
          imageClassName: "object-[center_30%]",
        }}
      />

      <section className="site-section relative">
        <PageDecorLayer variant="section" palette="site" />
        <div className="relative z-10 mx-auto max-w-7xl px-4 md:px-6">
          <h2 className="mb-8 text-center font-display text-2xl font-bold text-[var(--site-text)] md:text-3xl">
            Impact by sector
          </h2>
          <ImpactSectorShowcase categories={content.categories} />
          <ImpactGalleryStrip gallery={content.gallery} />
        </div>
      </section>
    </SitePageShell>
  );
}
